__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pad-tatico";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.7.0", () => (Promise.all([__webpack_require__.e(349), __webpack_require__.e(963), __webpack_require__.e(168)]).then(() => (() => (__webpack_require__(4349))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(963), __webpack_require__.e(664), __webpack_require__.e(367)]).then(() => (() => (__webpack_require__(4367))))));
			register("@mui/material", "5.10.1", () => (Promise.all([__webpack_require__.e(548), __webpack_require__.e(619), __webpack_require__.e(963), __webpack_require__.e(664), __webpack_require__.e(771)]).then(() => (() => (__webpack_require__(619))))));
			register("@mui/styles", "5.10.7", () => (Promise.all([__webpack_require__.e(389), __webpack_require__.e(963), __webpack_require__.e(116)]).then(() => (() => (__webpack_require__(8389))))));
			register("i18next", "21.6.14", () => (Promise.all([__webpack_require__.e(592), __webpack_require__.e(494)]).then(() => (() => (__webpack_require__(3592))))));
			register("react-dom", "17.0.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(963), __webpack_require__.e(123)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-i18next", "12.1.4", () => (Promise.all([__webpack_require__.e(963), __webpack_require__.e(815)]).then(() => (() => (__webpack_require__(6196))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(47), __webpack_require__.e(963), __webpack_require__.e(876)]).then(() => (() => (__webpack_require__(9047))))));
			register("react", "17.0.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};